import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Ministry = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddMinistry = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditMinistry = () => {
  return (
    
      
        <Edit />
      
    
  );
};
